import * as React from "react";
import { CategoryRow } from "./CategoryRow";
import type { CategoryId } from "./tokens";
import type { RowWithIndex } from "./types";
import type { RowReviewStatus } from "./utils";
import type { AiAnalysisViewModel } from "./hooks/useAiAnalysisViewModel";
import type { CategoryExpansion } from "./hooks/usePanelNavigation";

export type CategoryListProps = {
  vm: AiAnalysisViewModel;
  categoryExpansion: Record<CategoryId, CategoryExpansion>;
  selectedKey: string | null;
  focusedKey: string | null;
  aiRowStatus: Record<string, RowReviewStatus>;
  onToggleCategory: (category: CategoryId, count: number) => void;
  onExpandCategory: (category: CategoryId) => void;
  onCollapseCategory: (category: CategoryId) => void;
  onOpenIssue: (item: RowWithIndex, category: CategoryId) => void;
  onListKeyDown: (e: React.KeyboardEvent, category: CategoryId) => void;
  loading?: boolean;
};

const CATEGORIES: CategoryId[] = ["needsAttention", "needsReview", "compliant"];

export const CategoryList: React.FC<CategoryListProps> = ({
  vm,
  categoryExpansion,
  selectedKey,
  focusedKey,
  aiRowStatus,
  onToggleCategory,
  onExpandCategory,
  onCollapseCategory,
  onOpenIssue,
  onListKeyDown,
  loading,
}) => {
  if (loading && vm.rows.length === 0) {
    return (
      <div className="ai-analysis__category-list">
        <div className="ai-analysis__skeleton-row" />
        <div className="ai-analysis__skeleton-row" />
        <div className="ai-analysis__skeleton-row" />
      </div>
    );
  }

  return (
    <div className="ai-analysis__category-list">
      {CATEGORIES.map((category) => {
        const count =
          category === "needsAttention"
            ? vm.needsAttentionCount
            : category === "needsReview"
              ? vm.needsReviewCount
              : vm.compliantCount;
        return (
          <CategoryRow
            key={category}
            category={category}
            count={count}
            items={vm.getRowsForCategory(category)}
            expansion={categoryExpansion[category]}
            selectedKey={selectedKey}
            focusedKey={focusedKey}
            aiRowStatus={aiRowStatus}
            onToggle={() => onToggleCategory(category, count)}
            onExpand={() => onExpandCategory(category)}
            onCollapse={() => onCollapseCategory(category)}
            onOpenIssue={onOpenIssue}
            onKeyDown={(e) => onListKeyDown(e, category)}
          />
        );
      })}
    </div>
  );
};
